import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const loginValidationSchema = Yup.object().shape({
  email: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  password: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});

export const signUpValidationSchema = Yup.object().shape({
  fullName: Yup.string().required(SystemMessage.FULL_NAME_REQUIRED),
  username: Yup.string().required(SystemMessage.USERNAME_REQUIRED),
  email: Yup.string()
    .required(SystemMessage.INPUT_REQUIRED)
    .email(SystemMessage.EMAIL_ADDRESS_INVALID),
  password: Yup.string().required(SystemMessage.PASSWORD_REQUIRED),
  confirmPassword: Yup.string()
    .required(SystemMessage.CONFIRM_PASSWORD_REQUIRED)
    .oneOf([Yup.ref("password")], SystemMessage.CONFIRM_PASSWORD_INVALID),
  agree: Yup.array().min(1, SystemMessage.AGREE_TERMS_REQUIRED),
});

export const changePasswordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().required(SystemMessage.PASSWORD_REQUIRED),
  newPassword: Yup.string().required(SystemMessage.PASSWORD_REQUIRED),
  confirmPassword: Yup.string()
    .required(SystemMessage.CONFIRM_PASSWORD_REQUIRED)
    .oneOf([Yup.ref("newPassword")], SystemMessage.CONFIRM_PASSWORD_INVALID),
});
